module.exports = __webpack_public_path__ + "static/media/Overbite (deep bite)11.f12fa554.png";